import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapActions, mapState } from 'vuex'
import { KFormSelect } from '@kwixeo/form-vue'

@Component({
  methods: {
    ...mapActions('catalog', ['loadStockLocations'])
  },
  computed: {
    ...mapState('catalog', ['stockLocations'])
  },
  components: {
    KFormSelect
  }
})
export default class StockLocationSelect extends Vue {
  loadStockLocations!: (force?: boolean) => Promise<void>
  stockLocations!: KwixeoCatalog.StockLocations

  @Prop({ default: false }) selectDefault!: boolean|undefined
  @Prop({ default: null }) value!: KwixeoCatalog.StockLocation|null

  async created (): Promise<void> {
    await this.loadStockLocations()

    if (this.selectDefault !== false && !this.value && this.defaultLocation) {
      this.$emit('input', this.defaultLocation)
    }
  }

  get defaultLocation (): KwixeoCatalog.StockLocation|undefined {
    return this.stockLocations.find(location => location.use_default)
  }

  get attributes (): KwixeoInterface.GenericObject {
    return Object.assign({}, {
      value: this.value,
      clearable: false
    }, this.$attrs)
  }
}

